import React from 'react';
import type { SearchFieldState, SearchFieldActions } from '../../hooks';
import { FormField, SearchField } from '@/components/custom/erp';
import { donViSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { DonViCoSo } from '@/types/schemas';

interface FilterTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}

const FilterTab = ({ formState }: FilterTabProps) => {
  return (
    <div className='p-4'>
      {/* Đơn vị */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Đơn vị</Label>
        <SearchField<DonViCoSo>
          searchEndpoint={`/${QUERY_KEYS.DON_VI_CO_SO}/`}
          searchColumns={donViSearchColumns}
          columnDisplay='ma_unit'
          displayRelatedField='ten_unit'
          dialogTitle='Danh mục đơn vị'
          value={formState?.state.donVi?.ma_unit}
          relatedFieldValue={formState?.state.donVi?.ten_unit}
          onRowSelection={formState?.actions.setDonVi}
        />
      </div>

      {/* Trạng thái */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Trạng thái</Label>
        <FormField
          name='status'
          type='select'
          className='w-[200px]'
          options={[
            { value: '', label: 'Tất cả' },
            { value: '0', label: 'Lập chứng từ' },
            { value: '3', label: 'Chờ duyệt' },
            { value: '5', label: 'Trả lại' },
            { value: '6', label: 'Đang thực hiện' },
            { value: '7', label: 'Hoàn thành' },
            { value: '9', label: 'Hủy' }
          ]}
        />
      </div>

      {/* Lọc theo người SD */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Lọc theo người SD</Label>
        <FormField
          name='user_id0'
          type='select'
          className='w-[200px]'
          options={[
            { value: '', label: 'Tất cả' },
            { value: '1', label: 'Lọc theo người tạo' }
          ]}
        />
      </div>
    </div>
  );
};

export default FilterTab;
